<div class="modal" [class.modal-show]="isModalShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <h2>Замовлення файлом</h2>

  <div class="modal-body">
    <p class="modal-text">
      Завантажте файл <b>xlsx, xls, csv</b> або <b>txt</b>: перша колонка — артикул, друга — кількість.
      Якщо у файлі є шапка з назвами колонок (Артикул, Кіл-ть), вона теж розпізнається —
      підійде і файл з кнопки «Завантажити кошик в XLS».
    </p>

    <p class="modal-text">
      <a class="template-link" (click)="downloadTemplate()">Завантажити шаблон</a>
    </p>

    <div class="file-row">
      <label class="button modal-btn file-label" for="upload-order-file">Вибрати файл</label>
      <input id="upload-order-file" class="file-input" type="file" accept=".xlsx,.xls,.csv,.txt"
             (change)="onFileSelected($event)">
      <span class="file-name" *ngIf="fileName">{{ fileName }}</span>
    </div>

    <p class="error-text" *ngIf="errorMessage">{{ errorMessage }}</p>

    <div class="import-report" *ngIf="report">
      <p class="report-line success" *ngIf="report.added.length">
        Додано до кошика позицій: {{ report.added.length }}
      </p>
      <p class="report-line warning" *ngIf="!report.added.length">
        Жодної позиції не додано до кошика.
      </p>

      <p class="report-line warning" *ngIf="report.truncated">
        Оброблено лише перші {{ report.limit }} рядків файлу — решту не враховано.
      </p>

      <div class="report-block" *ngIf="partialItems.length">
        <p class="report-line warning">Додано менше, ніж у файлі (обмежено залишком):</p>
        <ul>
          <li *ngFor="let item of partialItems">
            рядок {{ item.row }}: {{ item.article }} — {{ item.added }} з {{ item.requested }} шт.
          </li>
        </ul>
      </div>

      <div class="report-block" *ngIf="report.out_of_stock.length">
        <p class="report-line warning">Немає в наявності:</p>
        <ul>
          <li *ngFor="let item of report.out_of_stock">
            рядок {{ item.row }}: {{ item.article }} {{ item.name }}
          </li>
        </ul>
      </div>

      <div class="report-block" *ngIf="report.not_found.length">
        <p class="report-line error">Не знайдено за артикулом:</p>
        <ul>
          <li *ngFor="let item of report.not_found">
            рядок {{ item.row }}: {{ item.article }}
          </li>
        </ul>
      </div>

      <div class="report-block" *ngIf="report.errors.length">
        <p class="report-line error">Не вдалося розібрати рядки:</p>
        <ul>
          <li *ngFor="let item of report.errors">
            рядок {{ item.row }}: {{ item.article }} — {{ item.message }}
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="modal-actions">
    <a class="button modal-btn" *ngIf="!report" [class.disabled]="!fileName || isUploading" (click)="uploadFile()">
      {{ isUploading ? 'Завантаження…' : 'Завантажити' }}
    </a>
    <a class="button modal-btn" *ngIf="report" (click)="closeModal()">Готово</a>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
